import { RiRefreshLine } from "react-icons/ri"
const Loader = () => {
    return <div className="fixed top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-white bg-opacity-80 z-10">
        <div className="text-4xl text-primary-900 animate-spin"><RiRefreshLine></RiRefreshLine></div>
    </div>
}

export default Loader